import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import JjfShell from "../HomePage2/JjfShell";
import AboutHero from "../../components/aboutHero/AboutHero";
import "../AboutUsPage/aboutV2.css";

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";

/* real Life Saver Army photo (public/images/initiatives-v2) */
const AboutUs = process.env.PUBLIC_URL + "/images/initiatives-v2/life-saver-army.jpg";

/* role cards */
const ROLES = [
  {
    title: "Hospitals",
    des: "Collaborate with Jainam Jivika Foundation to streamline emergency blood access and improve patient outcomes.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M4 21V7l8-4 8 4v14M4 21h16M10 12h4M12 10v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "Receivers",
    des: "Request blood or platelets and get connected with a verified local donor quickly; at no cost.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M3 12h4l2-5 4 10 2-5h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "Donors",
    des: "Register once to donate blood through Life Saver Army and become a lifeline for patients in your community.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>),
  },
  {
    title: "Volunteer",
    des: "Support Life Saver Army by assisting with donor drives, spreading awareness, or helping manage the platform.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M17 20v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm11 9v-2a4 4 0 0 0-3-3.87M16 4.13A4 4 0 0 1 16 11.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
];

/* why choose (clean icons) */
const WHY = [
  {
    title: "Personalised Opportunities",
    des: "Whether you are a donor, volunteer, hospital, or community leader; Life Saver Army connects you with the right role in the network.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" /><circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.8" /><circle cx="12" cy="12" r="1.6" fill="currentColor" /></svg>),
  },
  {
    title: "Simple to Join",
    des: "Register as a donor, request blood, or sign up to volunteer in minutes through our QR code or online platform.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M13 3 4 14h6l-1 7 9-11h-6l1-7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>),
  },
  {
    title: "Supportive Community",
    des: "Be part of a caring, active network where donors, volunteers, and coordinators work together to protect lives.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M17 20v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm11 9v-2a4 4 0 0 0-3-3.87M16 4.13A4 4 0 0 1 16 11.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "Always Available",
    des: "Our donor network is active around the clock, including rare blood types, so help is always reachable when it matters most.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" /><path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
];

/* how can you help (clean icons) */
const HELP = [
  {
    title: "As a Donor",
    des: "Register with Life Saver Army and save lives in your local community. Your single registration can help multiple patients.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>),
  },
  {
    title: "As a Receiver",
    des: "If you or a loved one needs blood urgently, register your request and let Life Saver Army connect you with a donor quickly.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M3 12h4l2-5 4 10 2-5h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "As a Hospital",
    des: "Partner with Jainam Jivika Foundation to give your patients a stronger safety net during blood emergencies.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M4 21V7l8-4 8 4v14M4 21h16M10 12h4M12 10v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "As a Volunteer",
    des: "Join Life Saver Army's ground team to spread awareness, organise donation events, and strengthen the network.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M17 20v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm11 9v-2a4 4 0 0 0-3-3.87M16 4.13A4 4 0 0 1 16 11.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  },
  {
    title: "As an Influencer",
    des: "Inspire your followers to register with Life Saver Army and use your reach to grow the nation's life-saving community.",
    icon: (<svg viewBox="0 0 24 24" fill="none"><path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M16 8a4 4 0 0 1 0 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>),
  },
];

const LifeSeverArmy = ({ path }) => {
  const [metadata, setMetadata] = useState({ title: "JJFIndia | Life Saver Army" });
  const [schemadata, setSchemadata] = useState({});

  useEffect(() => {
    let tempMetadata = metadataJSON[path];
    let tempSchemadata = schemadataJSON[path];
    if (tempMetadata) {
      setMetadata(tempMetadata);
    } else {
      setMetadata({
        title: "JJFIndia | Life Saver Army",
        description: "Life Saver Army - Jainam Jivika Foundation's flagship blood and platelet donor network.",
        keywords: "",
        robots: "index, follow",
        canonical: "https://jjfindia.com/initiatives/life-saver-army",
        openGraph: {
          title: "JJFIndia | Life Saver Army",
          description: "Life Saver Army - Jainam Jivika Foundation's flagship blood and platelet donor network.",
          url: "https://jjfindia.com/initiatives/life-saver-army",
        },
        twitter: { card: "summary_large_image", title: "JJFIndia | Life Saver Army", description: "Life Saver Army" },
      });
    }
    if (tempSchemadata) setSchemadata(tempSchemadata);
  }, [path]);

  return (
    <Fragment>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="robots" content={metadata.robots} />
        <link rel="canonical" href={metadata.canonical} />
        <meta property="og:title" content={metadata.openGraph?.title} />
        <meta property="og:description" content={metadata.openGraph?.description} />
        <meta property="og:url" content={metadata.canonical} />
        <meta name="twitter:title" content={metadata.twitter?.title} />
        <meta name="twitter:description" content={metadata.twitter?.description} />
        <script type="application/ld+json">{JSON.stringify(schemadata, null, 2)}</script>
      </Helmet>

      <JjfShell>
        {/* ===================== PAGE TITLE ===================== */}
        <AboutHero
          eyebrow="Our Flagship Initiative"
          title="Life Saver Army"
          crumbs={[
            { label: "Home", to: "/" },
            { label: "Our Initiative", to: "/initiatives/life-saver-army" },
            { label: "Life Saver Army" },
          ]}
        />

        {/* ===================== INTRO ===================== */}
        <section className="section about">
          <div className="wrap split">
            <div className="about-media reveal">
              <span className="leaf-frame" aria-hidden="true"></span>
              <div className="ph">
                <img src={AboutUs} alt="Life Saver Army - saving lives together" loading="eager" />
              </div>
              <div className="stat-card reveal d2"><div className="n">5.6K+</div><div className="l">Total registrations</div></div>
            </div>
            <div className="about-copy reveal d1">
              <span className="eyebrow">Powered by community</span>
              <h2>Saving Lives Together</h2>
              <p className="lead">
                Life Saver Army is Jainam Jivika Foundation's flagship initiative; a nationwide emergency blood and platelet donor network designed to ensure that no patient faces a blood crisis alone. Whether you want to register as a donor, request emergency blood, volunteer your time, or partner with us as a hospital or organisation, Life Saver Army makes it simple, fast, and community-powered.
              </p>
            </div>
          </div>
        </section>

        {/* ===================== ABOUT THE INITIATIVE ===================== */}
        <section className="section about" id="about">
          <div className="wrap" style={{ textAlign: "center", maxWidth: "830px", margin: "0 auto" }}>
            <span className="eyebrow reveal" style={{ justifyContent: "center" }}>About the Initiative</span>
            <h2 className="reveal d1" style={{ fontSize: "clamp(2rem,4.2vw,3.2rem)" }}>What is Life Saver Army?</h2>
            <p className="lead reveal d1">
              Life Saver Army is Jainam Jivika Foundation's most impactful social initiative; India's trusted platform connecting voluntary blood and platelet donors with patients in urgent need. Built on a QR-code-based registration system and powered by a network of field coordinators, community volunteers, and healthcare partnerships spanning many Indian states, it ensures that life-saving blood is always within reach.
            </p>
            <p className="lead reveal d2" style={{ marginTop: "1rem" }}>
              From the first confirmed life saved at Ram Krishna Mission Hospital, Varanasi, in June 2026, to an increasing number of registered donors and volunteers across India; Life Saver Army is proof that community action saves lives.
            </p>
          </div>

          <div className="wrap">
            <div className="ways">
              {ROLES.map((r, i) => (
                <article className={"way reveal" + (i % 4 ? " d" + (i % 4) : "")} key={r.title}>
                  <div className="wic">{r.icon}</div>
                  <h3>{r.title}</h3>
                  <p>{r.des}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ===================== WHY CHOOSE ===================== */}
        <section className="section section--mist">
          <div className="wrap" style={{ textAlign: "center" }}>
            <span className="eyebrow reveal" style={{ justifyContent: "center" }}>Your trusted partner in life-saving moments</span>
            <h2 className="reveal d1" style={{ fontSize: "clamp(2rem,4.2vw,3.2rem)" }}>Why Choose Life Saver Army?</h2>
          </div>
          <div className="wrap">
            <div className="init-grid">
              {WHY.map((f, i) => (
                <article className={"init reveal" + (i % 4 ? " d" + (i % 4) : "")} key={f.title}>
                  <span className="glow"></span>
                  <div className="badge">{f.icon}</div>
                  <h3>{f.title}</h3>
                  <p>{f.des}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ===================== HOW CAN YOU HELP ===================== */}
        <section className="section">
          <div className="wrap">
            <div className="sec-head sec-head--stack">
              <div className="reveal">
                <span className="eyebrow">How can you help?</span>
                <h2 style={{ lineHeight: 1.34 }}>Together for Life, One Drop at a Time</h2>
                <p className="lead reveal d1">
                Every role strengthens the network; pick the one that fits you best.
              </p>
              </div>
            </div>
            <div className="init-grid init-grid--5col">
              {HELP.map((f, i) => (
                <article className={"init reveal" + (i % 4 ? " d" + (i % 4) : "")} key={f.title}>
                  <span className="glow"></span>
                  <div className="badge">{f.icon}</div>
                  <h3>{f.title}</h3>
                  <p>{f.des}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ===================== COMMUNITY OF CARE ===================== */}
        <section className="section section--mist">
          <div className="wrap" style={{ textAlign: "center", maxWidth: "830px", margin: "0 auto" }}>
            <span className="eyebrow reveal" style={{ justifyContent: "center" }}>Uniting hearts to save lives</span>
            <h2 className="reveal d1" style={{ fontSize: "clamp(2rem,4.2vw,3.2rem)" }}>Building a Community of Care</h2>
            <p className="lead reveal d1" style={{ marginTop: "1.2rem" }}>
              Life Saver Army is more than a platform; it is a community built by Jainam Jivika Foundation where people come together to protect one another. Every donor who registers, every volunteer who shows up, and every hospital that partners with us adds another layer of strength to a network that saves real lives.
            </p>
          </div>
        </section>

        {/* ===================== JOIN CTA ===================== */}
        <section className="section">
          <div className="wrap">
            <div className="lsa-cta reveal">
              <span className="eyebrow">Why wait?</span>
              <h2>Join Life Saver Army Today!</h2>
              <p>
                Be part of Jainam Jivika Foundation's most impactful initiative. Whether you are donating blood, supporting patients, or volunteering your time; your contribution to Life Saver Army matters and the impact is real.
              </p>
              <div className="lsa-cta-actions">
                <a href="https://lifesaverarmy.com/donors/registration" target="_blank" rel="noopener noreferrer" className="btn btn--amber" data-burst="1">Register as a Donor</a>
                <a href="https://app.lifesaverarmy.com/getstarted" target="_blank" rel="noopener noreferrer" className="btn btn--amber">Request Blood</a>
                <a href="https://lifesaverarmy.com/volunteers" target="_blank" rel="noopener noreferrer" className="btn btn--outline-light">Volunteer With Us</a>
              </div>
            </div>
          </div>
        </section>
      </JjfShell>
    </Fragment>
  );
};

export default LifeSeverArmy;
